import CanvasJSReact from "../../../../canvasjs.react";
import React, { useState, useEffect } from "react";
import AppAdminContainer from "../AppAdminContainer";
import { PostApi, GetApi } from "../../../js_assets/Network";
import moment from "moment";
//var CanvasJSReact = require('./canvasjs.react');
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function Charts() {
  const [Admin_Info, setAdmin_Info] = useState(
    JSON.parse(localStorage.getItem("Admin_Info"))
  );
  const [isLoading, setIsLoading] = useState(true);
  const [rateData, setTRateData] = useState([]);
  const [satisfy, setSatisfy] = useState([]);
  const [commitment, setCommitment] = useState([]);
  const [resubscribe, setResubscribe] = useState([]);
  const [change, setChange] = useState([]);
  const [lose, setLose] = useState([]);
  const [gain, setGain] = useState([]);
  const [opinion, setOpinion] = useState([]);
  const [selectedDate, setHandleDateChange] = useState(new Date());
  const [select, setSelect] = useState("");

  function handleChange(event) {
    setSelect(event.target.value);
  }

  useEffect(() => {
    PostApi(
      `/api/Admin/Get_Subscription_Survey/${Admin_Info.admin_Id}`,
      Admin_Info.admin_Id,
      Admin_Info.jwT_Token_Admin
    ).then((rep) => {
      setTRateData(rep.result);
      let usersAnswers = [];
      let yesCounter = 0;
      let noCounter = 0;
      let sum = 0;
      let yes2Counter = 0;
      let no2Counter = 0;
      let mayCounter = 0;
      let sum2 = 0;
      let yes3Counter = 0;
      let no3Counter = 0;
      let may3Counter = 0;
      let sum3 = 0;
      let yes4Counter = 0;
      let no4Counter = 0;
      let may4Counter = 0;
      let sum4 = 0;
      //for "كم نقصت من وزنك خلال الشهر؟"
      let a = 0,
        b = 0,
        c = 0,
        d = 0,
        es = 0,
        f = 0,
        g = 0,
        sum5 = 0;
      // for  كم زدت
      let h = 0,
        i = 0,
        j = 0,
        k = 0,
        l = 0,
        sum6 = 0;
      // for  رأيك في المختص من 5؟
      let q = 0,
        m = 0,
        n = 0,
        o = 0,
        p = 0,
        sum7 = 0;

      let dates = rep.result.filter(
        (data) =>
          moment(data.subscription_Survey_DateTime).format("YYYY-MM") === select
      );
      console.log("dates2", dates);
      if (select) {
        dates.map((e) => {
          usersAnswers = JSON.parse(e.subscription_Survey_Result);
          usersAnswers.map((answer) => {
            if (answer.q === "هل كنت راضي عن النظام المقدم لك؟") {
              if (answer.a === "نعم") {
                yesCounter++;
              } else if (answer.a === "لا") {
                noCounter++;
              }
            } else if (answer.q === "هل عندك استعداد لتمديد الإشتراك؟") {
              if (answer.a === "نعم") {
                yes2Counter++;
              } else if (answer.a === "لا") {
                no2Counter++;
              } else if (answer.a === "ربما") {
                mayCounter++;
              }
            } else if (answer.q === "هل كنت ملتزم بالنظام؟") {
              if (answer.a === "نعم") {
                yes3Counter++;
              } else if (answer.a === "لا") {
                no3Counter++;
              } else if (answer.a === "أحيانًا") {
                may3Counter++;
              }
            } else if (answer.q === "هل كان فيه تغير بالشكل أو القياسات؟") {
              if (answer.a === "نعم") {
                yes4Counter++;
              } else if (answer.a === "لا") {
                no4Counter++;
              } else if (answer.a === "إلى حد ما") {
                may4Counter++;
              }
            } else if (answer.q === "كم نقصت من وزنك خلال الشهر؟") {
              if (answer.a === "كيلو واحد") {
                a++;
              } else if (answer.a === "كيلوين") {
                b++;
              } else if (answer.a === "3 كيلو") {
                c++;
              } else if (answer.a === "4 كيلو") {
                d++;
              } else if (answer.a === "5-6 كيلو") {
                es++;
              } else if (answer.a === "مانقصت كان فيه تقصير من المدرب") {
                f++;
              } else if (answer.a === "مانقصت بسبب عدم الالتزام") {
                g++;
              }
            } else if (answer.q === "كم زاد من وزنك خلال الشهر؟") {
              if (answer.a === "كيلو واحد") {
                h++;
              } else if (answer.a === "كيلوين") {
                i++;
              } else if (answer.a === "3 كيلو أو أكثر") {
                j++;
              } else if (answer.a === "ما زدت بسبب النظام") {
                k++;
              } else if (answer.a === "ما زدت بسبب التقصير مني") {
                l++;
              }
            } else if (answer.q === "رأيك في المختص من 5؟") {
              if (answer.a === "1") {
                m++;
              } else if (answer.a === "2") {
                n++;
              } else if (answer.a === "3") {
                o++;
              } else if (answer.a === "4") {
                p++;
              } else if (answer.a === "5") {
                q++;
              }
            }
          });
        });
      } else {
        rep.result.map((e) => {
          usersAnswers = JSON.parse(e.subscription_Survey_Result);
          usersAnswers.map((answer) => {
            if (answer.q === "هل كنت راضي عن النظام المقدم لك؟") {
              if (answer.a === "نعم") {
                yesCounter++;
              } else if (answer.a === "لا") {
                noCounter++;
              }
            } else if (answer.q === "هل عندك استعداد لتمديد الإشتراك؟") {
              if (answer.a === "نعم") {
                yes2Counter++;
              } else if (answer.a === "لا") {
                no2Counter++;
              } else if (answer.a === "ربما") {
                mayCounter++;
              }
            } else if (answer.q === "هل كنت ملتزم بالنظام؟") {
              if (answer.a === "نعم") {
                yes3Counter++;
              } else if (answer.a === "لا") {
                no3Counter++;
              } else if (answer.a === "أحيانًا") {
                may3Counter++;
              }
            } else if (answer.q === "هل كان فيه تغير بالشكل أو القياسات؟") {
              if (answer.a === "نعم") {
                yes4Counter++;
              } else if (answer.a === "لا") {
                no4Counter++;
              } else if (answer.a === "إلى حد ما") {
                may4Counter++;
              }
            } else if (answer.q === "كم نقصت من وزنك خلال الشهر؟") {
              if (answer.a === "كيلو واحد") {
                a++;
              } else if (answer.a === "كيلوين") {
                b++;
              } else if (answer.a === "3 كيلو") {
                c++;
              } else if (answer.a === "4 كيلو") {
                d++;
              } else if (answer.a === "5-6 كيلو") {
                es++;
              } else if (answer.a === "مانقصت كان فيه تقصير من المدرب") {
                f++;
              } else if (answer.a === "مانقصت بسبب عدم الالتزام") {
                g++;
              }
            } else if (answer.q === "كم زاد من وزنك خلال الشهر؟") {
              if (answer.a === "كيلو واحد") {
                h++;
              } else if (answer.a === "كيلوين") {
                i++;
              } else if (answer.a === "3 كيلو أو أكثر") {
                j++;
              } else if (answer.a === "ما زدت بسبب النظام") {
                k++;
              } else if (answer.a === "ما زدت بسبب التقصير مني") {
                l++;
              }
            } else if (answer.q === "رأيك في المختص من 5؟") {
              if (answer.a === "1") {
                m++;
              } else if (answer.a === "2") {
                n++;
              } else if (answer.a === "3") {
                o++;
              } else if (answer.a === "4") {
                p++;
              } else if (answer.a === "5") {
                q++;
              }
            }
          });
        });
      }
      sum = yesCounter + noCounter;
      sum2 = yes2Counter + no2Counter + mayCounter;
      sum3 = yes3Counter + no3Counter + may3Counter;
      sum4 = yes4Counter + no4Counter + may4Counter;
      sum5 = a + b + c + d + es + f + g;
      sum6 = h + i + j + k + l;
      sum7 = m + n + o + p + q;

      setSatisfy([
        ((yesCounter / sum) * 100).toFixed(0),
        ((noCounter / sum) * 100).toFixed(0),
        sum,
      ]);
      setResubscribe([
        ((yes2Counter / sum2) * 100).toFixed(0),
        ((no2Counter / sum2) * 100).toFixed(0),
        ((mayCounter / sum2) * 100).toFixed(0),
        sum2,
      ]);
      setCommitment([
        ((yes3Counter / sum3) * 100).toFixed(0),
        ((no3Counter / sum3) * 100).toFixed(0),
        ((may3Counter / sum3) * 100).toFixed(0),
        sum3,
      ]);
      setChange([
        ((yes4Counter / sum4) * 100).toFixed(0),
        ((no4Counter / sum4) * 100).toFixed(0),
        ((may4Counter / sum4) * 100).toFixed(0),
        sum4,
      ]);
      setLose([
        ((a / sum5) * 100).toFixed(0),

        ((b / sum5) * 100).toFixed(0),
        ((c / sum5) * 100).toFixed(0),
        ((d / sum5) * 100).toFixed(0),
        ((es / sum5) * 100).toFixed(0),

        ((f / sum5) * 100).toFixed(0),

        ((g / sum5) * 100).toFixed(0),

        sum5,
      ]);
      setGain([
        ((h / sum6) * 100).toFixed(0),
        ((i / sum6) * 100).toFixed(0),
        ((j / sum6) * 100).toFixed(0),
        ((k / sum6) * 100).toFixed(0),
        ((l / sum6) * 100).toFixed(0),
        sum6,
      ]);
      setOpinion([
        ((m / sum7) * 100).toFixed(0),
        ((n / sum7) * 100).toFixed(0),
        ((o / sum7) * 100).toFixed(0),
        ((p / sum7) * 100).toFixed(0),
        ((q / sum7) * 100).toFixed(0),
        sum7,
      ]);
    });
    setTimeout(() => setIsLoading(false), 5000);
  }, [select]);
  //   console.log("gain", gain);
  const options = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: `  الرضاء عن النظام : ${satisfy[2]} `,
    },
    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { y: satisfy[0], label: " راض " },
          { y: satisfy[1], label: "غير راض" },
        ],
      },
    ],
  };
  const options2 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: ` تجديد الاشتراك  : ${resubscribe[3]} `,
    },
    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { y: resubscribe[0], label: " نعم " },
          { y: resubscribe[2], label: "ربما" },
          { y: resubscribe[1], label: "لا" },
        ],
      },
    ],
  };
  const options3 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: `  الالتزام بالنظام  : ${commitment[3]} `,
    },
    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { y: commitment[0], label: " نعم " },
          { y: commitment[2], label: "احياناً" },
          { y: commitment[1], label: "لا" },
        ],
      },
    ],
  };
  const options4 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: ` التغير بالقياس  او الوزن    : ${change[3]} `,
    },
    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { y: change[0], label: " نعم " },
          { y: change[2], label: "إلى حد ما" },
          { y: change[1], label: "لا" },
        ],
      },
    ],
  };
  //   const options3 = {
  //     animationEnabled: true,
  //     exportEnabled: true,
  //     theme: "dark2", // "light1", "dark1", "dark2"
  //     title: {
  //       text: "احصائيات الاشتراكات  ",
  //     },

  //     data: [
  //       {
  //         type: "column",
  //         dataPoints: [
  //           { label: "Jan", y: 70 },
  //           { label: "feb", y: 55 },
  //           { label: "mar", y: 50 },
  //           { label: "apr", y: 65 },
  //           { label: "may", y: 95 },
  //           { label: "jun", y: 68 },
  //           { label: "Jul", y: 28 },
  //           { label: "aug", y: 34 },
  //           { label: "sep", y: 24 },
  //           { label: "oct", y: 64 },
  //           { label: "nov", y: 34 },
  //           { label: "dec", y: 24 },
  //         ],
  //       },
  //     ],
  //   };
  const options5 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: `نقص الوزن ${lose[7]}`,
    },

    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { label: "كيلو", y: lose[0] },
          { label: "كيلوين ", y: lose[1] },
          { label: "ثلاثه", y: lose[2] },
          { label: "اربعه", y: lose[3] },
          { label: "خمس-ست", y: lose[4] },
          { label: "تقصير-مدرب", y: lose[5] },
          { label: "عدم-التزام", y: lose[6] },
        ],
      },
    ],
  };
  const options6 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: `زيادة الوزن ${gain[5]}`,
    },

    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { label: "كيلو", y: gain[0] },
          { label: "كيلوين ", y: gain[1] },
          { label: "ثلاثه", y: gain[2] },
          { label: "بسبب النظام", y: gain[3] },
          { label: "تقصير مني", y: gain[4] },
        ],
      },
    ],
  };
  const options7 = {
    animationEnabled: true,
    exportEnabled: false,
    theme: "dark2", // "light1", "dark1", "dark2"
    title: {
      text: `تقييم المدرب   ${opinion[5]}`,
    },

    data: [
      {
        type: "pie",
        indexLabel: "{label}: %{y}",
        startAngle: -90,
        dataPoints: [
          { label: "1", y: opinion[0] },
          { label: "2 ", y: opinion[1] },
          { label: "3", y: opinion[2] },
          { label: "4 ", y: opinion[3] },
          { label: "5 ", y: opinion[4] },
        ],
      },
    ],
  };
  return (
    <AppAdminContainer Title={"الرسوم البيانية"}>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 950,

            borderStyle: "solid",
            padding: 5,
          }}
        >
          <span style={{ color: "#b1d236", fontSize: 20 }}>loading...</span>
        </div>
      ) : (
        <>
          <div
            style={{
              height: "100%",
              backgroundColor: "black",
              marginTop: "1%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginRight: "1%",
              }}
            >
              <div>
                <form>
                  <label>
                    {" "}
                    اختر الشهر{" "}
                    <select value={select.value} onChange={handleChange}>
                      <option value="">الكل</option>
                      <option value="2021-01">Jan</option>
                      <option value="2021-02">Feb</option>
                      <option value="2021-03">Mar</option>
                      <option value="2021-04">Apr</option>
                      <option value="2021-05">May</option>
                      <option value="2021-06">jun</option>
                      <option value="2021-07">jul</option>
                      <option value="2021-08">aug</option>
                      <option value="2021-09">Sep</option>
                      <option value="2021-10">Oct</option>
                      <option value="2021-11">Nov</option>
                      <option value="2021-12">Dec</option>
                    </select>
                  </label>
                </form>
              </div>
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", height: "100%" }}
            >
              <CanvasJSChart
                options={options}
                /* onRef={ref => this.chart = ref} */
              />
              <CanvasJSChart
                options={options2}
                /* onRef={ref => this.chart = ref} */
              />
              <CanvasJSChart
                options={options3}
                /* onRef={ref => this.chart = ref} */
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", height: "100%" }}
            >
              <CanvasJSChart
                options={options4}
                /* onRef={ref => this.chart = ref} */
              />
              <CanvasJSChart
                options={options5}
                /* onRef={ref => this.chart = ref} */
              />

              <CanvasJSChart options={options6} />
              {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", height: "100%" }}
            >
              <CanvasJSChart options={options7} />
            </div>
          </div>
        </>
      )}
    </AppAdminContainer>
  );
}

export default Charts;
